import { useState } from "react";
import { ReactComponent as BaseCorp } from "../../assets/icons/companylogo.svg";
import { ReactComponent as SubMenuIcon } from "../../assets/icons/sideBarIcon.svg";
import sidemenucss from "../../css/sidemenu.module.css"
import { useHistory } from 'react-router-dom';

const LoansSideBar = ({activeTab, subMenuItem, id, companyId}) =>{

    const [hideUnHideSubMenu, sethideUnHideSubMenu] = useState('A')

    const redirectTo = (link)=>{
        window.location.href=link
    }
    
    const routerHistory = useHistory();
    const handleClick = (Link) => {
        routerHistory.push(Link);
    };

    const subMenu = () => {
        if (hideUnHideSubMenu === 'A') {
            sethideUnHideSubMenu('I');
        } 
        else {
            sethideUnHideSubMenu('A');
        }
    }

    const menuItems = [
            {key: 1, label: "Overview", pagelink: `/myfinv2/loans/overview/${id}/${companyId}` },
            {key: 2, label: "Loan Listing", pagelink: `/myfinv2/loans/listing/${id}/${companyId}` },
            {key: 3,
                label: "Compute Calculations",
                subMenu: [
                    { label: "Staging", link: `/myfinv2/loans/staging/${id}/${companyId}`},
                    { label: "EIR", link: `/myfinV2/loans/eir/${id}/${companyId}`},
                    { label: "ECL", link: `/myfinV2/loans/ecl/${id}/${companyId}`},
                    { label: "IRAC", link: `/myfinV2/loans/irac/${id}/${companyId}`}
                ]
            },
        ];

    const activeItem = activeTab
    const activeItemSubMenu = subMenuItem

    return (
        <div className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}>
            <div className={sidemenucss.sidemenuHeader}>
            <BaseCorp className={sidemenucss.sidemenuCompanyLogoSize} />
                <span className={sidemenucss.sidemenuTitle}>Loan Register</span>
            </div>
            <div className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop}`}>
                <ul className={sidemenucss.sidemenuList}>
                    {menuItems.map((item, index) => (
                   
                        <div key={index}>
                            <li
                                onClick={() => {
                                    subMenu();
                                    if (item.pagelink) {
                                        setTimeout(() => handleClick(item.pagelink), 100);
                                    }
                                }}
                                className={`${sidemenucss.sidemenuItem} ${activeItem === item.label ? sidemenucss.sidemenuItemActive : ''}`}
                            >   
                                <span className={sidemenucss.sidemenuItemname}> 
                                    <div className={sidemenucss.sideMenuItemContainer}>
                                        {item.label} 
                                        <div className={sidemenucss.submenuIcon}>
                                            {item.subMenu ? (
                                                <SubMenuIcon className={`${sidemenucss.submenuIconSvg} ${hideUnHideSubMenu === 'A' ? null : sidemenucss.rotatedIcon}`} />
                                            ) : null}
                                        </div>
                                    </div> 
                                </span>
                            </li>

                            {item.subMenu ? (
                                <div className={`${sidemenucss.submenuContainer} ${hideUnHideSubMenu === 'A' ? sidemenucss.sideMenuShow : sidemenucss.sideMenuHide}`}>
                                    {item.subMenu.map((sub, idx) => (
                                        <div
                                            key={idx}
                                            className={`${sidemenucss.submenuItem} ${activeItemSubMenu === sub.label ? sidemenucss.activeSubMenu : null}`}
                                            onClick={() => handleClick(sub.link)}
                                        >
                                            {sub.label}
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </div>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default  LoansSideBar;